import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const buyers = [{
  name: 'María G.',
  location: 'Miami, FL',
  time: 'hace 2 min'
}, {
  name: 'Sofía R.',
  location: 'Houston, TX',
  time: 'hace 5 min'
}, {
  name: 'Ana P.',
  location: 'Los Angeles, CA',
  time: 'hace 3 min'
}, {
  name: 'Laura M.',
  location: 'Chicago, IL',
  time: 'hace 8 min'
}, {
  name: 'Carmen D.',
  location: 'New York, NY',
  time: 'hace 1 min'
}, {
  name: 'Isabel T.',
  location: 'Dallas, TX',
  time: 'hace 4 min'
}, {
  name: 'Patricia V.',
  location: 'Phoenix, AZ',
  time: 'hace 6 min'
}, {
  name: 'Elena S.',
  location: 'San Antonio, TX',
  time: 'hace 2 min'
}, {
  name: 'Rosa L.',
  location: 'Orlando, FL',
  time: 'hace 7 min'
}, {
  name: 'Claudia F.',
  location: 'Denver, CO',
  time: 'hace 3 min'
}, {
  name: 'Daniela H.',
  location: 'Atlanta, GA',
  time: 'hace 5 min'
}, {
  name: 'Fernanda B.',
  location: 'San Diego, CA',
  time: 'hace 1 min'
}];
export function LiveNotifications() {
  const [visible, setVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [usedIndices, setUsedIndices] = useState<number[]>([]);
  const pickRandomBuyer = useCallback(() => {
    let available = buyers.map((_, i) => i).filter(i => !usedIndices.includes(i));
    if (available.length === 0) {
      available = buyers.map((_, i) => i);
      setUsedIndices([]);
    }
    const randomIndex = available[Math.floor(Math.random() * available.length)];
    setUsedIndices(prev => [...prev, randomIndex]);
    return buyers[randomIndex];
  }, [usedIndices]);
  useEffect(() => {
    // Initial delay before first notification
    const initialDelay = setTimeout(() => {
      setCurrentBuyer(pickRandomBuyer());
      setVisible(true);
      // Hide after 4.5 seconds
      setTimeout(() => setVisible(false), 4500);
    }, 8000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    // Set up recurring notifications
    const interval = setInterval(() => {
      setCurrentBuyer(pickRandomBuyer());
      setVisible(true);
      setTimeout(() => setVisible(false), 4500);
    }, 18000 + Math.random() * 12000); // Random between 18-30 seconds
    return () => clearInterval(interval);
  }, [pickRandomBuyer]);
  return <div className="fixed bottom-4 left-4 z-40 pointer-events-none" data-id="element-128">
      <AnimatePresence data-id="element-129">
        {visible && <motion.div initial={{
        opacity: 0,
        x: -80,
        y: 20
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -80,
        y: 20
      }} transition={{
        duration: 0.5,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="pointer-events-auto bg-white rounded-2xl shadow-xl border border-sage/15 p-4 max-w-xs flex items-start gap-3" data-id="element-130">
            {/* Avatar */}
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-terracotta/15 flex items-center justify-center" data-id="element-131">
              <ShoppingBag className="w-5 h-5 text-terracotta" data-id="element-132" />
            </div>

            {/* Content */}
            <div className="min-w-0" data-id="element-133">
              <p className="text-sm text-charcoal leading-snug" data-id="element-134">
                <span className="font-bold" data-id="element-135">{currentBuyer.name}</span> acaba de
                descargar el protocolo
              </p>
              <p className="text-xs text-warmgray mt-1 flex items-center gap-1.5" data-id="element-136">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" data-id="element-137"></span>
                {currentBuyer.location} · {currentBuyer.time}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}